import styles from "./SectionTitle.module.css";

export const SectionTitle = ({ title, subtitle }) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      {/* <span className={styles.subtitle}>{subtitle}</span> */}
    </div>
  );
};
